/**
 * External dependencies
 */
import { DndProvider as ActualDndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// NOTE: This is a TS workaround.
export const DndProvider = ( {
	children,
}: {
	children: JSX.Element;
} ): JSX.Element => (
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore:next-line
	<ActualDndProvider backend={ HTML5Backend }>{ children }</ActualDndProvider>
);
